import { render } from "./FlyCheckbox.vue?vue&type=template&id=66fdc0f2"
import script from "./FlyCheckbox.vue?vue&type=script&lang=js"
export * from "./FlyCheckbox.vue?vue&type=script&lang=js"

import "./FlyCheckbox.vue?vue&type=style&index=0&id=66fdc0f2&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__